var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1363(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AirExperts_logo_rgb",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 436.388,
    height: 76,
    viewBox: "0 0 436.388 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.491,
    x2: 1,
    y2: 0.491,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5d9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5176bb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AirExperts_2021_RGB",
    transform: "translate(-3.09 -21.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5751",
    "data-name": "Group 5751",
    transform: "translate(3.09 21.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M-2035.416,21a4.246,4.246,0,0,1-2.991-1.234,4.239,4.239,0,0,1-1.241-3V-5.015a4.2,4.2,0,0,1,.579-2.13l26.135-44.773a4.246,4.246,0,0,1,3.646-2.1l393.074-.98h.007a4.212,4.212,0,0,1,2.983,1.234l.014.014h5.72a4.235,4.235,0,0,1,4.231,4.231V-44.3a4.235,4.235,0,0,1-4.231,4.232h-4.486V16.219a4.229,4.229,0,0,1-4.224,4.231l-419.209.55Z",
    transform: "translate(2039.647 55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5752",
    "data-name": "Group 5752",
    transform: "translate(54.344 26.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M86,29.88H97.225l-9,43.1H77Z",
    transform: "translate(-76.133 -29.175)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M88.443,73.386H75.77L85.058,28.88H97.723ZM77.5,71.975h9.788L96,30.29H86.207Z",
    transform: "translate(-75.77 -28.88)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5753",
    "data-name": "Group 5753",
    transform: "translate(72.941 26.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M112.3,29.88h21.128c7.849,0,13.822,1.989,13.822,11.17,0,6.46-3.082,11.044-9.838,12.01v.12c3.2.783,4.408,3.018,4.408,7.186,0,3.138-.183,5.557-.183,8.025a10.39,10.39,0,0,0,.663,4.591h-11.29a11.527,11.527,0,0,1-.36-2.475c0-2.236.3-4.527.3-7.426,0-3.8-1.629-5.8-5.613-5.8h-7.482L114.6,72.975H103.37Zm7.25,19.076h8.935c4.041,0,7.546-1.269,7.546-5.917,0-3.681-3.082-4.464-6.037-4.464h-8.272Z",
    transform: "translate(-102.503 -29.168)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M143.134,73.383H130.08l-.155-.719a11.38,11.38,0,0,1-.346-2.461c0-1.065.063-2.137.141-3.272.078-1.291.162-2.63.162-4.154,0-3.568-1.467-5.092-4.908-5.092h-6.911l-3.258,15.691H102.14l9.224-44.506h21.7c6.763,0,14.527,1.347,14.527,11.876,0,6.446-2.941,10.726-8.343,12.271,2,1.227,2.913,3.484,2.913,7.045,0,1.678-.049,3.124-.1,4.52-.042,1.213-.085,2.355-.085,3.5a9.891,9.891,0,0,0,.578,4.245Zm-11.911-1.41h9.682a15.1,15.1,0,0,1-.339-3.886c0-1.178.042-2.334.085-3.554.049-1.389.1-2.821.1-4.471,0-3.991-1.086-5.818-3.872-6.495l-.536-.134V52.149l.606-.085c7.63-1.093,9.231-6.756,9.231-11.312,0-7.433-3.8-10.465-13.117-10.465h-20.55l-8.639,41.685h9.788l3.258-15.691h8.061c4.252,0,6.319,2.13,6.319,6.5,0,1.566-.085,2.927-.169,4.238C131.06,68.136,131,69.18,131,70.2A8.513,8.513,0,0,0,131.223,71.972Zm-3.11-22.609h-9.8l2.468-11.791h8.843c5.571,0,6.742,2.814,6.742,5.169C136.364,45.76,134.932,49.363,128.113,49.363Zm-8.06-1.41h8.068c4.668,0,6.84-1.657,6.84-5.211,0-1.615-.55-3.759-5.331-3.759h-7.7Z",
    transform: "translate(-102.14 -28.87)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5754",
    "data-name": "Group 5754",
    transform: "translate(7.321 26.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M47.356,29.88H36.009L10.84,72.975H22.61L39.387,41.41l3.745,31.565h11.29Z",
    transform: "translate(-9.606 -29.175)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M54.731,73.386H41.988L38.434,43.428,22.517,73.386H9.09L35.084,28.88H47.439Zm-11.488-1.41h9.831L46.24,30.29H35.895L11.551,71.975h10.12L39.308,38.788Z",
    transform: "translate(-9.09 -28.88)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5755",
    "data-name": "Group 5755",
    transform: "translate(8.21 80.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M10.35,116.74V105.88h2.292v4.14H16.93v-4.14h2.292v10.86H16.93v-4.852H12.642v4.852Z",
    transform: "translate(-10.35 -105.598)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M34.916,107.8H29.077V110.1h5.36v1.89h-5.36v2.793h6.107v1.953H26.82V105.88h8.1Z",
    transform: "translate(-15.205 -105.598)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M44.715,105.87h2.609l3.907,10.86h-2.5L48,114.495H43.939l-.748,2.235H40.78Zm-.155,6.756h2.828l-1.4-4.274Z",
    transform: "translate(-19.321 -105.595)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M64.275,105.87V107.8h-3.3v8.942h-2.32V107.8H55.34V105.87Z",
    transform: "translate(-23.613 -105.595)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M72.592,116.74H70.3V105.88h2.292Z",
    transform: "translate(-28.023 -105.598)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M77.21,105.87h2.419l4.379,7.574V105.87h2.151v10.86H83.853l-4.492-7.708v7.708H77.21Z",
    transform: "translate(-30.06 -105.595)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M100.812,109.147a2.118,2.118,0,0,0-1.283-1.551,3.2,3.2,0,0,0-1.262-.24,2.784,2.784,0,0,0-2.193.987,4.448,4.448,0,0,0-.86,2.976,3.636,3.636,0,0,0,.931,2.828,3.072,3.072,0,0,0,2.109.832,2.765,2.765,0,0,0,1.9-.656,2.844,2.844,0,0,0,.917-1.721H98.52V110.79h4.6v5.832h-1.53l-.233-1.354a5.292,5.292,0,0,1-1.2,1.086,4.289,4.289,0,0,1-2.25.55,4.729,4.729,0,0,1-3.6-1.5,5.645,5.645,0,0,1-1.46-4.111,5.974,5.974,0,0,1,1.474-4.224,5.076,5.076,0,0,1,3.9-1.594,5.147,5.147,0,0,1,3.378,1.051,3.886,3.886,0,0,1,1.467,2.616Z",
    transform: "translate(-34.671 -105.48)",
    fill: "#ea1a21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5756",
    "data-name": "Group 5756",
    transform: "translate(93.469 80.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M135.22,105.87h2.63l3.935,10.86h-2.518l-.733-2.235h-4.1l-.755,2.235H131.25Zm-.155,6.756h2.849l-1.4-4.274Z",
    transform: "translate(-131.25 -105.546)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M150.9,116.74H148.59V105.88H150.9Z",
    transform: "translate(-136.362 -105.549)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M162.756,106.158a2.723,2.723,0,0,1,1.044.762,3.291,3.291,0,0,1,.557.917,3.029,3.029,0,0,1,.2,1.142,3.2,3.2,0,0,1-.4,1.523,2.211,2.211,0,0,1-1.319,1.058,2.09,2.09,0,0,1,1.093.86,3.534,3.534,0,0,1,.324,1.7v.726a5.192,5.192,0,0,0,.063,1.008.913.913,0,0,0,.43.621v.275h-2.567c-.071-.24-.12-.437-.148-.585a5.094,5.094,0,0,1-.1-.938l-.014-1.008a2,2,0,0,0-.367-1.382,1.894,1.894,0,0,0-1.326-.346h-2.271v4.259H155.69V105.89h5.324A4.694,4.694,0,0,1,162.756,106.158Zm-4.8,1.608v2.92h2.5a2.732,2.732,0,0,0,1.121-.176,1.218,1.218,0,0,0,.663-1.22,1.364,1.364,0,0,0-.635-1.326,2.368,2.368,0,0,0-1.072-.19h-2.581Z",
    transform: "translate(-138.455 -105.551)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M179.694,106.92a5.276,5.276,0,0,1,7.482.458,3.854,3.854,0,0,1,.762,2.024h-2.327a3,3,0,0,0-.571-1.178,2.321,2.321,0,0,0-1.841-.705,2.284,2.284,0,0,0-1.96,1,4.774,4.774,0,0,0-.719,2.828,4.222,4.222,0,0,0,.755,2.736,2.385,2.385,0,0,0,1.925.91,2.212,2.212,0,0,0,1.826-.783,3.4,3.4,0,0,0,.578-1.262h2.313a4.839,4.839,0,0,1-1.53,2.891,4.514,4.514,0,0,1-3.145,1.114,4.774,4.774,0,0,1-3.731-1.5,7,7,0,0,1,.183-8.533Z",
    transform: "translate(-145.076 -105.46)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M203.7,115.635a5.871,5.871,0,0,1-7.292,0,5.78,5.78,0,0,1-1.692-4.478,5.659,5.659,0,0,1,1.692-4.478,5.871,5.871,0,0,1,7.292,0,5.68,5.68,0,0,1,1.685,4.478A5.8,5.8,0,0,1,203.7,115.635Zm-1.453-1.65a5.336,5.336,0,0,0,0-5.656,2.917,2.917,0,0,0-4.393-.007,5.259,5.259,0,0,0,0,5.656,2.714,2.714,0,0,0,2.2.994A2.676,2.676,0,0,0,202.252,113.985Z",
    transform: "translate(-149.961 -105.41)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M212.97,105.87h2.44l4.415,7.574V105.87h2.165v10.86h-2.327l-4.527-7.708v7.708H212.97Z",
    transform: "translate(-155.341 -105.546)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M236.026,106.11a3.718,3.718,0,0,1,1.9,1.375,4.8,4.8,0,0,1,.79,1.756,8.2,8.2,0,0,1,.212,1.8,7.08,7.08,0,0,1-.889,3.667,4.036,4.036,0,0,1-3.731,2.024h-4.8V105.87h4.8A6.085,6.085,0,0,1,236.026,106.11Zm-4.259,1.65v7.087h2.144a2.319,2.319,0,0,0,2.3-1.587,5.406,5.406,0,0,0,.353-2.073,4.939,4.939,0,0,0-.536-2.546,2.274,2.274,0,0,0-2.123-.889h-2.137Z",
    transform: "translate(-160.216 -105.546)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M248.036,116.74H245.73V105.88h2.306Z",
    transform: "translate(-164.998 -105.549)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M260.432,105.87V107.8H257.1v8.942h-2.341V107.8H251.42V105.87Z",
    transform: "translate(-166.675 -105.546)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M268.826,116.74H266.52V105.88h2.306Z",
    transform: "translate(-171.127 -105.549)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M281.924,115.635a5.871,5.871,0,0,1-7.292,0,5.78,5.78,0,0,1-1.693-4.478,5.659,5.659,0,0,1,1.693-4.478,5.871,5.871,0,0,1,7.292,0,5.68,5.68,0,0,1,1.685,4.478A5.8,5.8,0,0,1,281.924,115.635Zm-1.453-1.65a5.336,5.336,0,0,0,0-5.656,2.917,2.917,0,0,0-4.393-.007,5.259,5.259,0,0,0,0,5.656,2.714,2.714,0,0,0,2.2.994A2.685,2.685,0,0,0,280.472,113.985Z",
    transform: "translate(-173.019 -105.41)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M291.19,105.87h2.44l4.415,7.574V105.87h2.165v10.86h-2.327l-4.527-7.708v7.708H291.19Z",
    transform: "translate(-178.399 -105.546)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M309.766,116.74H307.46V105.88h2.306Z",
    transform: "translate(-183.196 -105.549)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M314.42,105.87h2.44l4.415,7.574V105.87h2.165v10.86h-2.327l-4.527-7.708v7.708H314.42Z",
    transform: "translate(-185.247 -105.546)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M338.214,109.147a2.126,2.126,0,0,0-1.29-1.551,3.242,3.242,0,0,0-1.276-.24,2.813,2.813,0,0,0-2.207.987,4.41,4.41,0,0,0-.86,2.976,3.611,3.611,0,0,0,.938,2.828,3.11,3.11,0,0,0,2.13.832,2.721,2.721,0,0,0,2.842-2.377h-2.574V110.79h4.633v5.832h-1.537l-.233-1.354a5.158,5.158,0,0,1-1.206,1.086,4.342,4.342,0,0,1-2.264.55,4.78,4.78,0,0,1-3.625-1.5,5.623,5.623,0,0,1-1.474-4.111,5.919,5.919,0,0,1,1.488-4.224,5.143,5.143,0,0,1,3.935-1.594,5.228,5.228,0,0,1,3.406,1.051,3.868,3.868,0,0,1,1.474,2.616Z",
    transform: "translate(-189.902 -105.431)",
    fill: "#ea1a21"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_556",
    "data-name": "Ellipse 556",
    cx: 2.511,
    cy: 2.511,
    r: 2.511,
    transform: "translate(83.004 83.676)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_557",
    "data-name": "Ellipse 557",
    cx: 2.511,
    cy: 2.511,
    r: 2.511,
    transform: "translate(250.525 83.676)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5757",
    "data-name": "Group 5757",
    transform: "translate(426.813 26.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M604.525,32.4v.261a1.043,1.043,0,0,0,.24.776,1.025,1.025,0,0,0,.74.233.981.981,0,0,0,.74-.254.91.91,0,0,0,.247-.677,1.106,1.106,0,0,0-.12-.578.835.835,0,0,0-.4-.3l-1.079-.416a1.381,1.381,0,0,1-.733-.536,1.636,1.636,0,0,1-.176-.776,1.4,1.4,0,0,1,.4-1.03,1.42,1.42,0,0,1,1.044-.4,1.573,1.573,0,0,1,1.107.36,1.122,1.122,0,0,1,.388.867c0,.078,0,.162-.007.24h-.592a1.617,1.617,0,0,0,.007-.19.784.784,0,0,0-.811-.762.951.951,0,0,0-.712.233.976.976,0,0,0-.219.7.724.724,0,0,0,.515.726l.952.367a1.852,1.852,0,0,1,.825.536,1.342,1.342,0,0,1,.219.818,1.621,1.621,0,0,1-.409,1.157,1.588,1.588,0,0,1-1.206.437,1.619,1.619,0,0,1-1.128-.381,1.564,1.564,0,0,1-.416-1.2V32.4h.585Z",
    transform: "translate(-603.94 -28.7)",
    fill: "#070606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M609.63,28.88h1.022l1.178,4.591L613,28.88h1.023v5.226h-.578V29.254l-1.269,4.852h-.684l-1.269-4.852v4.852h-.578V28.88Z",
    transform: "translate(-605.617 -28.753)",
    fill: "#070606"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5758",
    "data-name": "Group 5758",
    transform: "translate(18.52 46.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M25.344,69.87c11.382-3.7,22.284-6.657,33.695-8.145q15.867-2.063,31.791-3.364c8.025-.663,16.036-1.015,24.033-1.142,63.13-.98,126.2,5.649,189.256,8.829,19.1.966,38.194,1.805,57.3,2.313,7.179.19,14.358.324,21.537.656,7.2.331,14.45-.19,21.608,1.22.959.19,1.982,5.042,2.863,5.592s-1.855-3.124-1.53-1.911c.416,1.544,4.936,1.735,5.888,1.925.98.2,6.248.381,6.728,1.791.7,2.052-2.4,4.549-3.47,4.7-22.136,3.23-45.676,4.259-69.8,3.85-23.709-.4-47.446-1.382-71.12-3.427-20.176-1.742-40.31-4.295-60.443-6.833-23.688-2.983-47.383-5.966-71.141-7.715-15.091-1.114-30.2-1.728-45.309-1.523-9.922.134-19.837.282-29.753.55-7.094.19-14.189.458-21.276.931s-14.153,1.22-21.227,1.848",
    transform: "translate(-24.97 -57.121)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5759",
    "data-name": "Group 5759",
    transform: "translate(172.988 26.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M266.328,50.215,256.251,29.87h12.376l5.134,13.279,9.9-13.279h13.519L279.255,50.391l10.62,22.574H277.139l-5.733-14.309L260.172,72.972H246.23Z",
    transform: "translate(-244.664 -29.165)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M290.328,73.383H276.005l-5.458-13.618L259.863,73.383H244.01l20.825-23.575L254.461,28.87h13.991L273.3,41.409l9.351-12.539h15.43L279.433,50.217Zm-13.371-1.41h11.149L277.761,49.984l17.207-19.7H283.353L272.9,44.3,267.486,30.28H256.732l9.788,19.746L247.141,71.965h12.038l11.77-15Z",
    transform: "translate(-244.01 -28.87)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5760",
    "data-name": "Group 5760",
    transform: "translate(220.589 26.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M321.795,29.88h21.184c7.729,0,12.433,5.19,12.433,12.856,0,10.867-8.025,16.3-18.533,16.3h-9.957l-2.955,13.942H312.74Zm7.059,19.915h7.905c5.19,0,7.426-2.475,7.426-6.037,0-4.168-3.258-4.647-6.763-4.647h-6.34Z",
    transform: "translate(-311.873 -29.175)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M324.176,73.386H311.51l9.351-44.506h21.763c7.983,0,13.138,5.324,13.138,13.561,0,10.486-7.369,17-19.238,17h-9.386Zm-10.931-1.41h9.788l2.955-13.942h10.529c10.994,0,17.828-5.973,17.828-15.592,0-7.5-4.492-12.151-11.728-12.151H322ZM336.4,50.205h-8.773l2.525-12.094h6.911c2.426,0,7.468,0,7.468,5.353C344.528,47.751,341.566,50.205,336.4,50.205Zm-7.045-1.41H336.4c4.393,0,6.721-1.841,6.721-5.331,0-3.3-2.221-3.942-6.058-3.942h-5.769Z",
    transform: "translate(-311.51 -28.88)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5761",
    "data-name": "Group 5761",
    transform: "translate(261.759 25.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M380.042,28.5h34.407L412.4,39.134H390.19l-1.389,5.91h18.448l-1.812,9.668H386.988L385.3,61.948h22.383l-2.052,10.627H371.1Z",
    transform: "translate(-370.247 -27.788)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M405.863,72.976H369.89l9.217-45.486h35.839l-2.327,12.045H390.39l-1.058,4.5h18.406l-2.073,11.079H387.189l-1.361,5.825h22.355Zm-34.245-1.41H404.7l1.777-9.224H384.058l2.017-8.646h18.42l1.544-8.258H387.548l1.721-7.32h22.179l1.777-9.224H380.264Z",
    transform: "translate(-369.89 -27.49)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5762",
    "data-name": "Group 5762",
    transform: "translate(137.135 25.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M203.328,28.5h34.407l-2.052,10.635H213.476l-1.389,5.91h18.448l-1.812,9.668H210.274l-1.692,7.235h22.383l-2.052,10.627H194.4Z",
    transform: "translate(-193.533 -27.788)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M229.143,72.976H193.17l9.217-45.486h35.839L235.9,39.535H213.67l-1.058,4.5h18.406l-2.073,11.079H210.476l-1.361,5.825H231.47ZM194.9,71.565h33.081l1.777-9.224H207.338l2.017-8.646h18.42l1.544-8.258H210.828l1.721-7.32h22.179l1.777-9.224H203.529Z",
    transform: "translate(-193.17 -27.49)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5763",
    "data-name": "Group 5763",
    transform: "translate(303.303 26.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M438.948,29.88h21.128c7.849,0,13.822,1.989,13.822,11.17,0,6.46-3.082,11.044-9.838,12.01v.12c3.2.783,4.408,3.018,4.408,7.186,0,3.138-.183,5.557-.183,8.025a10.388,10.388,0,0,0,.663,4.591h-11.29a11.525,11.525,0,0,1-.36-2.475c0-2.236.3-4.527.3-7.426,0-3.8-1.629-5.8-5.613-5.8H444.5l-3.258,15.691H430.02Zm7.242,19.076h8.935c4.048,0,7.546-1.269,7.546-5.917,0-3.681-3.082-4.464-6.037-4.464h-8.272Z",
    transform: "translate(-429.16 -29.168)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M469.779,73.383H456.733l-.148-.705a11.573,11.573,0,0,1-.346-2.475c0-1.065.063-2.137.141-3.272.078-1.291.162-2.63.162-4.154,0-3.568-1.467-5.092-4.908-5.092h-6.911l-3.258,15.691H428.8l9.224-44.506h21.7c6.763,0,14.527,1.347,14.527,11.876,0,6.446-2.941,10.726-8.343,12.271,2,1.227,2.913,3.484,2.913,7.045,0,1.678-.049,3.124-.1,4.52-.042,1.213-.085,2.355-.085,3.5a9.891,9.891,0,0,0,.578,4.245Zm-11.911-1.41h9.682a15.1,15.1,0,0,1-.338-3.886c0-1.178.042-2.334.085-3.554.049-1.389.1-2.821.1-4.471,0-3.991-1.086-5.818-3.872-6.495l-.536-.134V52.149l.606-.085c7.63-1.093,9.231-6.756,9.231-11.311,0-7.433-3.8-10.465-13.117-10.465h-20.55l-8.639,41.685h9.788l3.258-15.691h8.061c4.252,0,6.319,2.13,6.319,6.5,0,1.566-.085,2.927-.169,4.238-.07,1.114-.134,2.158-.134,3.18A8.513,8.513,0,0,0,457.869,71.972Zm-3.1-22.609h-9.8l2.468-11.791h8.843c5.571,0,6.742,2.814,6.742,5.169C463.017,45.76,461.585,49.363,454.766,49.363Zm-8.068-1.41h8.068c4.668,0,6.841-1.657,6.841-5.211,0-1.615-.55-3.759-5.331-3.759h-7.694Z",
    transform: "translate(-428.8 -28.87)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5764",
    "data-name": "Group 5764",
    transform: "translate(349.423 25.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M532.059,41.071h-11.7L513.3,72.565H501.1L508.159,40.1H495.48l2.905-11.608h36.579Z",
    transform: "translate(-494.577 -27.785)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M513.48,72.976H499.842L506.9,40.508H494.2l3.258-13.018h38.018l-3.23,13.991h-11.7Zm-11.89-1.41h10.761l7.059-31.494h11.706L533.7,28.9H498.558l-2.553,10.2H508.65Z",
    transform: "translate(-494.2 -27.49)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5765",
    "data-name": "Group 5765",
    transform: "translate(386.092 25.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M558.41,58.11c0,4.647,2.6,6.156,7.905,6.156,4.527,0,6.4-1.932,6.4-4.288,0-4.288-6.516-4.767-10.987-6.34-5.374-1.932-9.718-4.767-9.718-11.107,0-9.781,8.872-13.942,17.5-13.942,9.175,0,16.96,3.378,16.657,13.885H574.94a4.107,4.107,0,0,0-1.509-3.5,7.4,7.4,0,0,0-4.527-1.149c-2.778,0-5.677,1.149-5.677,3.865,0,2.6,1.812,2.9,7.849,4.527,5.917,1.629,12.856,4.711,12.856,13.159,0,7.666-6.819,14.125-19.435,14.125-10.261,0-17.447-5.19-17.327-15.395H558.41Z",
    transform: "translate(-546.484 -27.899)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M564.224,73.921c-5.952,0-10.776-1.692-13.942-4.894-2.764-2.8-4.14-6.573-4.083-11.206l.007-.7h12.63v.705c0,3.97,1.953,5.451,7.2,5.451,3.618,0,5.691-1.3,5.691-3.582,0-2.771-3.5-3.7-7.193-4.7-1.121-.3-2.278-.614-3.321-.973-4.746-1.707-10.19-4.584-10.19-11.77,0-10.12,9.147-14.647,18.208-14.647,6.326,0,11.022,1.53,13.963,4.556,2.377,2.447,3.519,5.825,3.4,10.049l-.021.684H573.956v-.705a3.417,3.417,0,0,0-1.227-2.941,6.708,6.708,0,0,0-4.1-1.008c-1.848,0-4.965.663-4.965,3.159,0,1.763.776,2.087,6.185,3.54l1.143.31c5.747,1.58,13.378,4.739,13.378,13.836C584.365,66.474,578.138,73.921,564.224,73.921ZM547.61,58.526a13.451,13.451,0,0,0,3.674,9.506c2.9,2.927,7.369,4.478,12.94,4.478,12.94,0,18.73-6.742,18.73-13.42,0-8.046-6.594-10.9-12.341-12.482l-1.135-.3c-5.261-1.41-7.228-1.939-7.228-4.9,0-3.159,3.2-4.57,6.375-4.57a8,8,0,0,1,4.958,1.291,4.542,4.542,0,0,1,1.756,3.357H585.2a11.615,11.615,0,0,0-3.011-8.343c-2.666-2.743-7.024-4.133-12.955-4.133-12.4,0-16.8,7.13-16.8,13.237,0,6.269,4.675,8.8,9.252,10.444.987.346,2.116.649,3.216.945,3.865,1.037,8.237,2.207,8.237,6.058,0,1.171-.515,4.993-7.1,4.993-4.09,0-8.265-.755-8.589-6.156Z",
    transform: "translate(-546.198 -27.61)",
    fill: "#004175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5766",
    "data-name": "Group 5766",
    transform: "translate(261.484 80.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M371.813,116.7H369.5V105.56h2.313Z",
    transform: "translate(-369.5 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M375.81,105.56h2.44l4.422,7.764V105.56h2.165V116.7h-2.327l-4.534-7.9v7.9H375.81Z",
    transform: "translate(-371.36 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M398.23,105.81a3.667,3.667,0,0,1,1.9,1.41,5.011,5.011,0,0,1,.8,1.8,8.629,8.629,0,0,1,.212,1.841,7.37,7.37,0,0,1-.9,3.766,4.033,4.033,0,0,1-3.738,2.08h-4.8V105.57h4.8A5.63,5.63,0,0,1,398.23,105.81Zm-4.267,1.692v7.271h2.151a2.318,2.318,0,0,0,2.3-1.622,5.671,5.671,0,0,0,.353-2.123,5.163,5.163,0,0,0-.536-2.609,2.253,2.253,0,0,0-2.123-.91h-2.144Z",
    transform: "translate(-376.044 -105.231)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M415.954,115.569a5.771,5.771,0,0,1-7.292,0,6.01,6.01,0,0,1-1.692-4.591,5.886,5.886,0,0,1,1.692-4.591,5.771,5.771,0,0,1,7.292,0,5.908,5.908,0,0,1,1.685,4.591A6.006,6.006,0,0,1,415.954,115.569Zm-1.453-1.692a5.585,5.585,0,0,0,0-5.8,2.655,2.655,0,0,0-2.193-1.023,2.682,2.682,0,0,0-2.207,1.023,5.5,5.5,0,0,0,0,5.8,2.7,2.7,0,0,0,2.207,1.023A2.645,2.645,0,0,0,414.5,113.877Z",
    transform: "translate(-380.546 -105.09)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M433.024,115.569a5.771,5.771,0,0,1-7.292,0,6.01,6.01,0,0,1-1.692-4.591,5.886,5.886,0,0,1,1.692-4.591,5.771,5.771,0,0,1,7.292,0,5.908,5.908,0,0,1,1.685,4.591A6.033,6.033,0,0,1,433.024,115.569Zm-1.453-1.692a5.585,5.585,0,0,0,0-5.8,2.654,2.654,0,0,0-2.193-1.023,2.691,2.691,0,0,0-2.207,1.023,5.5,5.5,0,0,0,0,5.8,2.7,2.7,0,0,0,2.207,1.023A2.645,2.645,0,0,0,431.572,113.877Z",
    transform: "translate(-385.578 -105.09)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M448.853,105.852a2.833,2.833,0,0,1,1.044.776,3.405,3.405,0,0,1,.557.938,3.207,3.207,0,0,1,.2,1.171,3.31,3.31,0,0,1-.4,1.559,2.252,2.252,0,0,1-1.319,1.086,2.086,2.086,0,0,1,1.093.881,3.7,3.7,0,0,1,.317,1.742v.748a5.493,5.493,0,0,0,.064,1.037.926.926,0,0,0,.43.635v.282h-2.567c-.07-.247-.12-.444-.148-.6a5.393,5.393,0,0,1-.1-.959l-.014-1.037a2.088,2.088,0,0,0-.367-1.417,1.856,1.856,0,0,0-1.326-.353h-2.271v4.365H441.78V105.57H447.1A4.67,4.67,0,0,1,448.853,105.852Zm-4.81,1.65v2.99h2.5a2.692,2.692,0,0,0,1.121-.183,1.258,1.258,0,0,0,.663-1.255,1.4,1.4,0,0,0-.642-1.361,2.279,2.279,0,0,0-1.079-.2h-2.567Z",
    transform: "translate(-390.808 -105.232)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M465.677,105.56h2.63L472.25,116.7h-2.525l-.733-2.292h-4.1l-.755,2.292H461.7Zm-.155,6.932h2.849l-1.4-4.379Z",
    transform: "translate(-396.68 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M480.713,116.7H478.4V105.56h2.313Z",
    transform: "translate(-401.603 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M491.933,105.852a2.832,2.832,0,0,1,1.044.776,3.4,3.4,0,0,1,.557.938,3.207,3.207,0,0,1,.2,1.171,3.31,3.31,0,0,1-.4,1.559,2.252,2.252,0,0,1-1.319,1.086,2.086,2.086,0,0,1,1.093.881,3.7,3.7,0,0,1,.317,1.742v.748a5.493,5.493,0,0,0,.064,1.037.926.926,0,0,0,.43.635v.282h-2.567c-.071-.247-.12-.444-.148-.6a5.393,5.393,0,0,1-.1-.959l-.014-1.037a2.088,2.088,0,0,0-.367-1.417,1.856,1.856,0,0,0-1.326-.353h-2.271v4.365H484.86V105.57h5.324A4.723,4.723,0,0,1,491.933,105.852Zm-4.809,1.65v2.99h2.5a2.692,2.692,0,0,0,1.121-.183,1.258,1.258,0,0,0,.663-1.255,1.4,1.4,0,0,0-.642-1.361,2.278,2.278,0,0,0-1.079-.2h-2.567Z",
    transform: "translate(-403.507 -105.232)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M516.43,113.306a4.175,4.175,0,0,1-.867,1.594l1.276,1.206-1.213,1.269-1.34-1.269a5.549,5.549,0,0,1-1.058.522,5.638,5.638,0,0,1-1.791.247,5.11,5.11,0,0,1-3.6-1.3,6.948,6.948,0,0,1,.049-9.21,5.2,5.2,0,0,1,3.59-1.276,5.135,5.135,0,0,1,3.625,1.354,5.663,5.663,0,0,1,1.693,4.372A7.636,7.636,0,0,1,516.43,113.306Zm-4.224,1.5a3.834,3.834,0,0,0,.522-.19l-1.128-1.072,1.2-1.248,1.135,1.065a5.052,5.052,0,0,0,.367-.952,5.367,5.367,0,0,0,.169-1.425,4.74,4.74,0,0,0-.769-2.9,2.623,2.623,0,0,0-2.243-1.023,2.728,2.728,0,0,0-2.207.98,4.487,4.487,0,0,0-.825,2.941,4.082,4.082,0,0,0,1.178,3.279,2.738,2.738,0,0,0,1.826.642A3.077,3.077,0,0,0,512.206,114.8Z",
    transform: "translate(-409.775 -105.09)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M523.764,105.56h2.362v6.84a3.972,3.972,0,0,0,.268,1.678,2.254,2.254,0,0,0,3.66,0,3.841,3.841,0,0,0,.268-1.678v-6.84h2.362v6.848a5.729,5.729,0,0,1-.55,2.764q-1.026,1.809-3.914,1.812t-3.921-1.812a5.749,5.749,0,0,1-.55-2.764V105.56Z",
    transform: "translate(-414.972 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M542.467,105.56h2.63L549.04,116.7h-2.525l-.734-2.292h-4.1l-.755,2.292H538.49Zm-.155,6.932h2.849l-1.4-4.379Z",
    transform: "translate(-419.317 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M555.46,105.56h2.327v9.132h5.557v2H555.46Z",
    transform: "translate(-424.32 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M570.9,116.7H568.59V105.56H570.9Z",
    transform: "translate(-428.191 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M582.66,105.56v1.975h-3.328V116.7H576.99v-9.168h-3.35V105.56Z",
    transform: "translate(-429.679 -105.229)",
    fill: "#ea1a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M594.334,105.56h2.637l-3.723,6.96V116.7H590.92V112.52l-3.85-6.96h2.743l2.313,4.852Z",
    transform: "translate(-433.638 -105.229)",
    fill: "#ea1a21"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1363);
export default __webpack_public_path__ + "static/media/logo_1363.14aa0f2e3eb86404cc29bf53eab89491.svg";
export { ForwardRef as ReactComponent };